import { NavItemModel } from '../../common';

export const ORDER_HISTORY_ORDERS_ROUTE_NAME: string = 'orders';
export const ORDER_HISTORY_ORDERS_ROUTE_PATH: string = 'orders';
export const orderHistoryOrdersNavItem: NavItemModel = {
  name: ORDER_HISTORY_ORDERS_ROUTE_NAME,
  url: `/${ORDER_HISTORY_ORDERS_ROUTE_PATH}`,
  label: 'Bestellübersicht',
  description: 'Übersicht aller Bestellungen und Bestellstatus',
  icon: {
    name: 'table-list',
    family: 'light',
  },
};

export const ORDER_HISTORY_ORDER_ROUTE_PATH: string = 'order/:orderId';

export const ORDERS_RECENT_PRODUCTS_ROUTE_NAME: string = 'ordered-products';
export const ORDERS_RECENT_PRODUCTS_ROUTE_PATH: string = 'ordered-products';
export const ordersRecentProductsNavItem: NavItemModel = {
  name: ORDERS_RECENT_PRODUCTS_ROUTE_NAME,
  url: `/${ORDERS_RECENT_PRODUCTS_ROUTE_PATH}`,
  label: 'Zuletzt bestellte Artikel',
  description: 'Übersicht der zuletzt bestellten Artikel',
  icon: {
    name: 'list-dropdown',
    family: 'light',
  },
};

export const ORDERS_SHOPPING_LISTS_ROUTE_NAME: string = 'shopping-lists';
export const ORDERS_SHOPPING_LISTS_ROUTE_PATH: string = 'shopping-lists';
export const ordersShoppingListsNavItem: NavItemModel = {
  name: ORDERS_SHOPPING_LISTS_ROUTE_NAME,
  url: `/${ORDERS_SHOPPING_LISTS_ROUTE_PATH}`,
  label: 'Einkaufslisten verwalten',
  description: 'Erstellen und verwalten von Einkaufslisten',
  icon: {
    name: 'list-tree',
    family: 'light',
  },
};

export const ORDERS_SHOPPING_LIST_DETAIL_ROUTE_NAME: string = 'shopping-list-detail';
export const ORDERS_SHOPPING_LIST_DETAIL_ROUTE_PATH: string = 'shopping-lists/:listId';
export const orderShoppingListDetailNavItem: NavItemModel = {
  name: ORDERS_SHOPPING_LIST_DETAIL_ROUTE_NAME,
  url: `/${ORDERS_SHOPPING_LIST_DETAIL_ROUTE_PATH}`,
  label: 'Einkaufsliste',
};

export const ORDERS_QUICK_ORDER_ROUTE_NAME: string = 'quick-order';
export const ORDERS_QUICK_ORDER_ROUTE_PATH: string = 'quick-order';
export const quickOrderNavItem: NavItemModel = {
  name: ORDERS_QUICK_ORDER_ROUTE_NAME,
  url: `/${ORDERS_QUICK_ORDER_ROUTE_PATH}`,
  label: 'Schnellerfassung',
  icon: {
    name: 'scanner-touchscreen',
    family: 'light',
  },
};

export const orderNavigation: NavItemModel[] = [
  orderHistoryOrdersNavItem,
  ordersRecentProductsNavItem,
  ordersShoppingListsNavItem,
];
